import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { send_feedback } from 'store/modules/panel_store/actions';
import { ApplicationState } from 'store';
import Loader from 'components/atoms/loader';
import createTrack from 'services/actions/tracker_actions';
import { Container } from './styles';

const EvaluationSession: React.FC = () => {
  const dispatch = useDispatch();
  const { panel, request_send_feedback } = useSelector(
    (state: ApplicationState) => state.session.panel,
  );
  const [selectedScore, setSelectedScore] = useState<number>();
  const [feedback, setFeedback] = useState('');
  const [evaluated, setEvaluated] = useState(panel?.evaluated);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleFeedbackChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    setFeedback(event.target.value);
  };

  const handleSubmit = async () => {
    createTrack('Dashboard - Enviou feedback');
    setIsLoading(true);
    if (selectedScore !== undefined && feedback) {
      dispatch(send_feedback(selectedScore, feedback));
      setIsLoading(false);
      setEvaluated(false);
      setSelectedScore(undefined);
      setShowSuccessMessage(true);
    }
  };

  return (
    <Container className="text-center p-5">
      {showSuccessMessage && !evaluated && <p className="mb-0">Resposta enviada com sucesso!</p>}

      {!evaluated && !showSuccessMessage && !isLoading ? (
        <div>
          <p className="font-weight-bold">
            Qual a probabilidade de você indicar o ConLicitação para alguém?
          </p>
          <div className="scale-wrapper">
            <span className="label">Muito improvável</span>
            <div className="buttons-wrapper">
              {Array.from({ length: 11 }, (_, index) => (
                <button
                  type="button"
                  key={index}
                  className={`btn btn-outline-primary ${selectedScore === index ? 'current' : ''}`}
                  onClick={() => setSelectedScore(index)}
                >
                  {index}
                </button>
              ))}
            </div>
            <span className="label">Muito provável</span>
          </div>
        </div>
      ) : evaluated && !showSuccessMessage ? (
        <span>
          Você já respondeu nossa pesquisa.
          <button type="button" className="btn btn-link pl-1" onClick={() => setEvaluated(false)}>
            Gostaria de responder novamente.
          </button>
        </span>
      ) : null}

      {selectedScore && !isLoading && (
        <div className="row justify-content-center mt-4 d-flex">
          {selectedScore >= 9 && (
            <span>
              Ficamos muito felizes por sua boa experiência! Nos ajude a oferecer uma experiência
              ainda melhor com um feedback.
            </span>
          )}
          <div className="col-md-8">
            <div className="notes-input-group d-flex align-items-start">
              <textarea
                className="form-control feedback-textarea"
                placeholder="Escreva um feedback"
                value={feedback}
                onChange={handleFeedbackChange}
                onInput={(e) => {
                  const target = e.target as HTMLTextAreaElement;
                  target.style.height = 'auto';
                  target.style.height = `${target.scrollHeight}px`;
                }}
                rows={1}
                style={{
                  resize: 'none',
                  flexGrow: 1,
                }}
              />
              <button
                type="button"
                className="btn btn-input-send ms-2"
                onClick={handleSubmit}
                disabled={request_send_feedback?.loading}
              >
                Enviar
              </button>
            </div>
          </div>
        </div>
      )}
      {isLoading && (
        <div className="py-5">
          <Loader />
        </div>
      )}
    </Container>
  );
};

export default EvaluationSession;
